<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
<!--            <a-col :md="8" :sm="24">-->
<!--              <a-form-item label="观看数" prop="lookNum">-->
<!--                <a-input v-model="queryParam.lookNum" placeholder="请输入观看数" allow-clear/>-->
<!--              </a-form-item>-->
<!--            </a-col>-->
<!--            <a-col :md="8" :sm="24">-->
<!--              <a-form-item label="前多少集可以使用金币观看" prop="limitNum">-->
<!--                <a-input v-model="queryParam.limitNum" placeholder="请输入前多少集可以使用金币观看" allow-clear/>-->
<!--              </a-form-item>-->
<!--            </a-col>-->
<!--            <template v-if="advanced">-->
<!--              <a-col :md="8" :sm="24">-->
<!--                <a-form-item label="每集钻石价格" prop="diamondPrice">-->
<!--                  <a-input v-model="queryParam.diamondPrice" placeholder="请输入每集钻石价格" allow-clear/>-->
<!--                </a-form-item>-->
<!--              </a-col>-->
<!--              <a-col :md="8" :sm="24">-->
<!--                <a-form-item label="每集金币价格" prop="goldPrice">-->
<!--                  <a-input v-model="queryParam.goldPrice" placeholder="请输入每集金币价格" allow-clear/>-->
<!--                </a-form-item>-->
<!--              </a-col>-->
<!--              <a-col :md="8" :sm="24">-->
<!--                <a-form-item label="简介" prop="describe">-->
<!--                  <a-input v-model="queryParam.describe" placeholder="请输入简介" allow-clear/>-->
<!--                </a-form-item>-->
<!--              </a-col>-->
<!--              <a-col :md="8" :sm="24">-->
<!--                <a-form-item label="标签ids" prop="tagIds">-->
<!--                  <a-input v-model="queryParam.tagIds" placeholder="请输入标签ids" allow-clear/>-->
<!--                </a-form-item>-->
<!--              </a-col>-->
<!--              <a-col :md="8" :sm="24">-->
<!--                <a-form-item label="总集数" prop="totalNum">-->
<!--                  <a-input v-model="queryParam.totalNum" placeholder="请输入总集数" allow-clear/>-->
<!--                </a-form-item>-->
<!--              </a-col>-->
              <a-col :md="6" :sm="24">
                <a-form-item label="剧名" prop="videoName">
                  <a-input v-model="queryParam.videoName" placeholder="请输入剧名" allow-clear/>
                </a-form-item>
              </a-col>

            <a-col :md="6" :sm="24">
              <a-form-item label="是否上映" prop="isRelease">
                <a-select placeholder="请选择是否上映" v-model="queryParam.isRelease">
                  <a-select-option :key="0">否</a-select-option>
                  <a-select-option :key="1">是</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>

            <a-col :md="6" :sm="24">
              <a-form-model-item label="地区" prop="countryId" >
                <a-select show-search placeholder="请选择" v-model="queryParam.countryId">
                  <a-select-option v-for="item in countryList" :value="item.id">{{item.countryName}}</a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
<!--            <a-col :md="6" :sm="24">-->
<!--              <a-form-item label="上映时间" prop="releaseTime">-->
<!--                <a-date-picker style="width: 100%" v-model="queryParam.releaseTime" format="YYYY-MM-DD" allow-clear/>-->
<!--              </a-form-item>-->
<!--            </a-col>-->
            <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
            <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
<!--              <a-col :md="8" :sm="24">-->
<!--                <a-form-item label="封面图" prop="coverUrl">-->
<!--                  <a-input v-model="queryParam.coverUrl" placeholder="请输入封面图" allow-clear/>-->
<!--                </a-form-item>-->
<!--              </a-col>-->
<!--            </template>-->
<!--            <a-col :md="!advanced && 8 || 24" :sm="24">-->
<!--              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">-->
<!--               -->
<!--&lt;!&ndash;                <a @click="toggleAdvanced" style="margin-left: 8px">&ndash;&gt;-->
<!--&lt;!&ndash;                  {{ advanced ? '收起' : '展开' }}&ndash;&gt;-->
<!--&lt;!&ndash;                  <a-icon :type="advanced ? 'up' : 'down'"/>&ndash;&gt;-->
<!--&lt;!&ndash;                </a>&ndash;&gt;-->
<!--              </span>-->

          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['video:video:add']">
          <a-icon type="plus" />新增
        </a-button>
<!--        <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)" v-hasPermi="['video:video:edit']">-->
<!--          <a-icon type="edit" />修改-->
<!--        </a-button>-->
        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['video:video:remove']">
          <a-icon type="delete" />删除
        </a-button>
<!--        <a-button type="dashed" @click="$refs.importExcel.importExcelHandleOpen()">-->
<!--          <a-icon type="import" />导入-->
<!--        </a-button>-->
<!--        <a-button type="primary" @click="handleExport">-->
<!--          <a-icon type="download" />导出-->
<!--        </a-button>-->
<!--        <a-button type="primary" @click="handleExport" v-hasPermi="['video:video:export']">-->
<!--          <a-icon type="download" />导出-->
<!--        </a-button>-->
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />
      <!-- 上传文件 -->
      <import-excel ref="importExcel" @ok="getList" />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
           <img slot="coverUrl" slot-scope="text, record" style="width: 48px;height: 48px;" :preview="record.coverUrl" v-image-preview :src="record.coverUrl">

        <span slot="isBan" slot-scope="text, record">
          <a-switch checkedChildren="是" unCheckedChildren="否" v-model="record.isBan == 0" @change="changeIsOpen($event,record)"/>
        </span>

        <span slot="operation" slot-scope="text, record">
          <a-divider type="vertical" v-hasPermi="['video:video:edit']" />
          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['video:video:edit']">
            <a-icon type="edit" />修改
          </a>
          <a-divider type="vertical" />
           <a @click="$refs.Gather.getLists(record.id)">
            <a-icon type="search" />剧集管理
          </a>
          <a-divider type="vertical" v-hasPermi="['video:video:remove']" />
          <a @click="handleDelete(record)" v-hasPermi="['video:video:remove']">
            <a-icon type="delete" />删除
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
        :rowKey="(record, index) => index + 1"
      />
    </a-card>
    <gather ref="Gather"></gather>
  </page-header-wrapper>
</template>

<script>
import { pageVideo,listVideo, delVideo ,changeIsOpen} from '@/api/video/video'
import CreateForm from './modules/CreateForm'
import Gather from '../gather/index'
import { tableMixin } from '@/store/table-mixin'
import ImportExcel from './modules/ImportExcel'
import moment from "moment";
import {listCountry} from "@/api/video/country";

export default {
  name: 'Video',
  components: {
    CreateForm,
    Gather,
    ImportExcel
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: true,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      videoNames: [],
      countryList:[],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        lookNum: null,
        limitNum: null,
        countryId: null,
        diamondPrice: null,
        goldPrice: null,
        describe: null,
        tagIds: null,
        totalNum: null,
        videoName: null,
        coverUrl: null,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: '序号',

          customRender: (text, record, index) => index + 1,
          width: '10%',
          align: 'center'
        },
        // {
        //   title: '导入id',
        //   dataIndex: 'id',
          // ellipsis: true,,
        //   width: '20%',
        //   align: 'center'
        // },
        {
          title: '剧名',
          dataIndex: 'videoName',
          width: '20%',
          align: 'center'
        },
        // {
        //   title: '英文剧名',
        //   dataIndex: 'videoNameEn',
        //   align: 'center'
        // },
        {
          title: '封面图',
          dataIndex: 'coverUrl',
          align: 'center',
          width: '20%',
          scopedSlots: { customRender: 'coverUrl' }
        },
        {
          title: '总集数',
          dataIndex: 'totalNum',
          width: '10%',
          align: 'center'
        },

        {
          title: '地区',
          dataIndex: 'countryName',
          width: '10%',
          align: 'center'
        },

        {
          title: '是否启用',
          dataIndex: 'isBan',
          width: '10%',
          align: 'center',
          scopedSlots: { customRender: 'isBan' },
        },
        // {
        //   title: '前多少集可以使用金币观看',
        //   dataIndex: 'limitNum',
        //   // ellipsis: true,,
        //   align: 'center'
        // },
        {
          title: '每集钻石价格',
          dataIndex: 'diamondPrice',
          width: '10%',
          align: 'center'
        },
        {
          title: '排序',
          dataIndex: 'seqSort',
          width: '10%',
          align: 'center'
        },
        {
          title: '热度排序',
          dataIndex: 'heatSort',
          width: '10%',
          align: 'center'
        },
        {
          title: '最受欢迎排序',
          dataIndex: 'welcomeSort',
          width: '10%',
          align: 'center'
        },
        {
          title: '是否上映',
          dataIndex: 'isRelease',
          width: '10%',
          customRender: function (t, r, index) {
            if(t == 0) {
              return '否'
            }else if(t == 1) {
              return '是'
            }
          },
          align: 'center'
        },
        {
          title: '上映时间',
          dataIndex: 'releaseTime',
          // ellipsis: true,,
          width: '20%',
          align: 'center'
        },
        {
          title: '分类',
          dataIndex: 'tagIds',
          width: '10%',
          align: 'center'
        },


        // {
        //   title: '创建时间',
        //   dataIndex: 'createTime',
        //   scopedSlots: { customRender: 'createTime' },
        //   // ellipsis: true,,
        //   align: 'center'
        // },
        // {
        //   title: '备注',
        //   dataIndex: 'remark',
        //   // ellipsis: true,,
        //   align: 'center'
        // },
        {
          title: '观看数',
          dataIndex: 'lookNum',
          width: '10%',
          align: 'center'
        },
        {
          title: '操作',
          dataIndex: 'operation',
          ellipsis: true,
          width: '30%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  created () {
    this.getList()
    this.getCountry()
  },
  activated() {
    this.getCountry()
  },
  computed: {
  },
  watch: {
  },
  methods: {

    getCountry(){
      listCountry().then(res=>{
        this.countryList = res.data
      })
    },
    filterOption (input, option){
      return option.value.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    },
    /** 查询短剧列表 */
    getList () {
      this.loading = true
      if (this.queryParam.releaseTime) {
        if (moment.isMoment(this.queryParam.releaseTime)) {
          this.queryParam.releaseTime = this.queryParam.releaseTime.format('YYYY-MM-DD')
        }
      }
     pageVideo(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },
    changeIsOpen (e,record) {
      record.isBan = e ? 0 : 1
      changeIsOpen(record).then(response => {
        this.$message.success(
          '操作成功'
        )
        return  record.isBan = e ? 0 : 1
      })
    },
    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        lookNum: undefined,
        limitNum: undefined,
        diamondPrice: undefined,
        goldPrice: undefined,
        describe: undefined,
        tagIds: undefined,
        totalNum: undefined,
        videoName: undefined,
        coverUrl: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.queryParam.pageNum = 1
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if (row.id) {
        this.ids.push(row.id)
      }
      this.$confirm({
        title: '确认删除所选中数据?',
        // content: '当前选中剧名为' + videoNames + '的数据',
        onOk () {
          let data = []
          that.ids.map(id => data.push({"id":id}))
          return delVideo(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                '删除成功',
                3
              )
          })
        },
        onCancel () {
          //取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk () {
          that.download('video/video/export', {
            ...that.queryParam
          }, `短剧_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    }
  }
}
</script>
